import React, { Dispatch, useEffect, useRef } from 'react';
import { ICOA } from '../interfaces';
import Xarrow, { Xwrapper } from 'react-xarrows';
import Draggable from 'react-draggable';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { NODE_CONNECTOR_COLOR, NODE_HIGHLIGHT_COLOR } from './NodeWrapper';

interface COADotsProps {
    coaId: number;
    srcNodeId: string;
    updateXarrow: any;
    coa: ICOA;
    showDeleteCOA: boolean;
    deleteLine: () => void;
    nodeHeight: string;
    setTranslate: Dispatch<string>;
    translate: string;
    deleteLeft: string;
    deleteTop: string;
  }

const COADotsDiv: React.FC<COADotsProps> = ({ coaId, srcNodeId, updateXarrow, coa, showDeleteCOA, deleteLine, nodeHeight, translate, setTranslate, deleteLeft, deleteTop }) => {

    const [, updateState] = React.useState<any>();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    let renderCount = useRef<number>(0) 

    useEffect(() => {
        renderCount.current++
        const clickCOA1: HTMLElement = document.getElementById(`elem${srcNodeId}${coaId}1`)!;
        const clickCOA2: HTMLElement = document.getElementById(`elem${srcNodeId}${coaId}2`)!;
        const deleteCOA: HTMLElement = document.getElementById(`delete${srcNodeId}${coaId}`)!;
        
        if (coa.nextNodeId !== '') {
            if (clickCOA1 !== null && clickCOA2 !== null && deleteCOA !== null) {
                const txpSvg: HTMLElement = clickCOA2.nextElementSibling as HTMLElement;
                const path = txpSvg.querySelector('svg path');
                if (path !== null) {
                    const highlightPath = () => {
                        txpSvg.style.zIndex = '23001';
                        path.setAttribute('stroke', NODE_HIGHLIGHT_COLOR);
                    };
                    const resetPath = () => {
                        txpSvg.style.zIndex = ''
                        path.setAttribute('stroke', NODE_CONNECTOR_COLOR);
                    }

                    clickCOA1.addEventListener('mouseover', highlightPath);
                    clickCOA2.addEventListener('mouseover', highlightPath);
                    clickCOA1.addEventListener('mouseout', resetPath);
                    clickCOA2.addEventListener('mouseout', resetPath);
                }

                const nodes: NodeListOf<Element> = document.querySelectorAll('.node')!;
                if (nodes !== null) {
                    let allNodes1: HTMLElement[] = Array.from(nodes) as HTMLElement[]
                    
                    let nodeToConnect = allNodes1.filter((node: HTMLElement) => node.dataset.id === coa.nextNodeId)
                    
                    if (nodeToConnect[0] !== undefined) {
                        let connectedDot = nodeToConnect[0].querySelector('.node-dot1')
                        let sourceNode = allNodes1.filter((node: HTMLElement) => node.dataset.id === srcNodeId)
                        let coaInject = sourceNode[0].querySelector('.coa-inject')
                        if (coaInject !== null) {
                            const COAX: string = (connectedDot!.getBoundingClientRect().x - clickCOA1.getBoundingClientRect().x) + 'px'
                            const COAY: string = (connectedDot!.getBoundingClientRect().y - clickCOA1.getBoundingClientRect().y) + 'px'
                                
                            setTranslate('translate('+COAX+', '+COAY+')');
                        }
                    }
                }
            }
        }
        
    }, [coa.nextNodeId, nodeHeight])  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        forceUpdate()
    }, [translate])  // eslint-disable-line react-hooks/exhaustive-deps
    
    return (
        <div id={`wrap${srcNodeId}${coaId}1`} className="coa-dots-wrapper" data-id="1">
            <div id={`delete${srcNodeId}${coaId}`} className="delete-line" onClick={deleteLine} style={{ top: deleteTop, left: deleteLeft }}><div className="delete-line-inner" style={{ visibility: showDeleteCOA ? 'visible' : 'hidden' }}>Delete Line</div></div>
            <Xwrapper>
                { coa.nextNodeId === '' ? <Draggable onDrag={updateXarrow} onStop={updateXarrow}>
                    <div id={`elem${srcNodeId}${coaId}1`} className={`drag-elem1`}></div>
                </Draggable> : <div id={`elem${srcNodeId}${coaId}1`} className={`drag-elem1`}></div> }
                
                { coa.nextNodeId === '' ? <Draggable onDrag={updateXarrow} onStop={updateXarrow}><div id={`elem${srcNodeId}${coaId}2`} className={`drag-elem2`} data-tooltip-id={`coa-tooltip${srcNodeId}${coaId}2`} data-tooltip-content="Drag to a Node" data-tooltip-place="top"  data-id="1"></div></Draggable> : <div id={`elem${srcNodeId}${coaId}2`} className={`drag-elem2`} style={{ transform: translate }} data-id="2"></div> }
                
                <Xarrow start={`elem${srcNodeId}${coaId}1`} end={`elem${srcNodeId}${coaId}2`} showHead={false} color={NODE_CONNECTOR_COLOR} />
            </Xwrapper>
            <Tooltip id={`coa-tooltip${srcNodeId}${coaId}2`} className="sidemenu-tooltip" />
        </div>
    )
}

export default COADotsDiv;